<template>
  <div class="content">
    <b-container class="p-2 m-0 top-metrics-container">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <b-row slot="header">
              <b-col>
                  <span class="h4 font-weight-bold mb-0 nowrap" v-if="title">{{ title }}</span>
              </b-col>
              <b-col class="text-right pl-1 pr-1 nowrap" v-if="$slots.icon || icon">
                  <span class="h5 font-weight-bold mb-0" v-if="mPlan" style="margin-left: -4px;">
                        <b-badge variant="warning" class="m-1 cursor-pointer bg-orange text-white border-radius-none" v-on:click="managePlanFunc()">
                          <i class="fa fa-file text-dark"></i>
                          {{mPlan}}
                        </b-badge>
                  </span>
                  <span class="h6 font-weight-bold mb-0 " v-if="alerts">
                    <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTopMetricTab(alerts)"
                                 v-bind:class="btnActivated === alerts ? 'bg-warning text-white' : ''"
                    >{{ alerts }}</base-button>
                  </span>
                  <span class="h6 font-weight-bold mb-0" v-if="monitors">
                    <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTopMetricTab(monitors)"
                                 v-bind:class="btnActivated === monitors ? 'bg-warning text-white' : ''">
                      {{ monitors }}</base-button>
                  </span>
                  <span class="h6 font-weight-bold mb-0" v-if="dPlan">
                    <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTopMetricTab(dPlan)"
                                 v-bind:class="btnActivated === dPlan ? 'bg-warning text-white' : ''">
                      {{ dPlan }}</base-button>
                  </span>
                <slot name="icon" class="pl-2">
                  <b-icon
                      icon="question-circle"
                      variant="orange"
                      class="mr-1 vertical-align-35"
                      v-b-tooltip.hover.top="tooltip">
                  </b-icon>
                </slot>
                <slot name="icon" class="pl-2 ml-2">
                  <b-icon
                      :icon="icon1"
                      variant="orange"
                      class="vertical-align-35"
                      @click="dataManagementToggle()"
                      v-b-tooltip.hover.top="'Click here to enable or disable this item'"
                  ></b-icon>
                </slot>
              </b-col>
            </b-row>
          </template>

          <transition name="slide-fade">
            <div v-if="toggleStatus">
              <div class="text-center w-100">
                <b-icon icon="three-dots"
                        class="text-center " animation="cylon"
                        font-scale="4"
                        v-if="loadingStatus"></b-icon>
              </div>
              <div class="mb-3 m-2" v-if="!loadingStatus">
                <b-row class="">
                  <b-col cols="12" xl="8" lg="7" md="7" sm="6">
                    <b-form-group
                      label=""
                      label-for="per-page-select"
                      label-cols-sm="0"
                      label-cols-md="0"
                      label-cols-lg="0"
                      label-align-sm="center"
                      label-size="sm"
                      class="mb-2 per-page-select"
                    >
                    <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
                    <b-form-select
                      id="per-page-select"
                      class="diameter-report-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                      v-on:input="changePageOption(perPage)"
                    ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
                    <b-form-group
                      label=""
                      label-for="filter-input"
                      label-align-sm="right"
                      label-size="sm "
                      class="mb-0 per-page-select"
                    >
                      <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
                      <b-input-group size="sm">
                        <b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-table
                  striped hover
                  :items="tableData"
                  :fields="tableColumns"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  head-variant="light"
                  table-class="text-nowrap"
                  class="data-management-table primary-table"
                  sticky-header="true"
                  thead-class="white"
                  show-empty
                  responsive
                  small
                >
                  <template #cell(imsi)="row" >
                    <b-link class="d-block-custom link-custom nowrap" :to="'/sim_detail/:?imsi=' + row.item['imsi']">
                      {{row.value}} <i class="ni ni-curved-next"></i>
                    </b-link>
                  </template>

                  <template #cell(dateCreated)="row" >
                    <span class="nowrap">{{row.value}}</span>
                  </template>
                  <!-- eslint-disable -->
                  <template #cell(action)="row" >
                    <span class="nowrap">
                      <i class="fa cursor-pointer fa-marker text-warning mr-3"></i>
                      <i class="fa cursor-pointer fa-trash-alt text-danger"></i>
                    </span>
                  </template>
                  <!-- eslint-enable -->
                </b-table>

                <b-row class="mt-4">
                  <b-col >
                    <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
                  </b-col>
                  <b-col >
                    <b-pagination
                      class="flex-fill-custom pr-4 ml-3 justify-content-end"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      size="sm"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
          </transition>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
    import cardOpenStatusDirective from "../../../common/directive/card-open-status-directive";
    import searchDashboardService from "@/common/api-services/search-dashboard-service";
    import pagination from '../../../common/format/pagination'

    export default {
        name: "DataManagement",
      components: {

      },
      props: {
        type: {
          type: String,
          default: 'primary'
        },
        tabId: String,
        icon: String,
        title: String,
        mPlan: String,
        alerts: String,
        monitors: String,
        dPlan: String,
        iconClasses: [String, Array],
        color: String,
        tooltip: String,
      },
      data() {
        return {
          loadingStatus: true,
          toggleStatus: false,
          icon1: 'arrow-right-square',
          downIcon: 'arrow-down-square',
          rightIcon: 'arrow-right-square',
          btnActivated: 'Alerts',
          propsToSearch: ['IMSI', 'Data Volume'],
          tableColumns: [],
          tableData: [],
          selectedRows: [],
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [5, 10, 25],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          filterOn: [],
        };
      },
      mounted() {
        this.getCardStatus();

        this.$root.$on('fetchDataManagement', ($event) => {
          this.loadingStatus = false;
          let i = 1;
          this.tableColumns = [];
          this.tableData = [];
          switch (this.btnActivated) {
            case this.alerts: {
              this.tableColumns = alertsColumn;
              break;
            }
            case this.monitors: {
              this.tableColumns = monitorsColumn;
              break;
            }
            case this.dPlan: {
              this.tableColumns = dataPlansColumn;
              break;
            }
          }
          if ($event && $event.includes('NULL')) {
            this.tableData = [];
            this.totalRows = 0;
          } else {
            if ($event) {
              if (this.btnActivated === 'Alerts' && $event[0].name === 'No Alerts') {
                this.tableData = [];
                this.totalRows = 0;
              } else {
                if ($event.includes('No')) {
                  this.tableData = [];
                  this.totalRows = 0
                } else {

                  $event.map(item => {
                    item.No = i;
                    i++
                  });
                  this.tableData = $event;
                  this.totalRows = $event.length;
                }
                if (this.totalRows < this.perPage) {
                  this.fromPage = this.totalRows
                }
              }
            }
          }
          this.getTotalRows();
        })
      },
      methods: {
        getCardStatus() {
          let cardStatus = cardOpenStatusDirective.getOpenCardStatus()['topMetrics-collapse'];
          if (cardStatus) {
            this.icon1 = this.downIcon;
            this.toggleStatus = cardStatus;
          }
        },

        changePageOption(page) {
          this.getTotalRows();
        },

        changeTopMetricTab(title) {
          this.loadingStatus = true;
          this.$emit('dataManagementTab', title);
          this.btnActivated = title;
        },

        dataManagementToggle() {
          let status = cardOpenStatusDirective.setWatchdogAlertStatus();
          if (status) {
            this.toggleStatus = !this.toggleStatus;
            if (this.toggleStatus) {
              this.icon1 = this.downIcon;
            } else {
              this.icon1 = this.rightIcon
            }
            this.$root.$emit('topMetricsOpen', this.btnActivated)
          }
        },
        managePlanFunc() {
          this.$bvModal.show('change-data-plan');
          let imsi = window.location.href.split('?imsi=')[1];
          let data = [];
          let items = [];
          searchDashboardService.getDataBucketList(imsi).then(res => {
            searchDashboardService.getWatchDogs(imsi).then(res1 => {
              res.map(item => {
                if (item.value.split('default_')[1]) {
                  items.push({value: item.value.split('default_')[1] + ' : ' + item.text, key: item.value})
                } else {
                  items.push({value: '*' + item.value.split(imsi + '_')[1] + ' : ' + item.text, key: item.value});
                  data.defaultSelect = item.value;
                }
              });
              data.option = items;
              data.imsi = imsi;
              data.msg = res1;
              this.$root.$emit('changeDataPlan', data)
            })
          })
        },

        getTotalRows() {
          if (this.perPage > this.totalRows) {
            this.fromPage = this.totalRows;
          } else {
            this.fromPage = this.perPage;
          }
        },
        startPage() {
          return pagination.startPageFunc(this.currentPage, this.perPage)
        },
        lastPage() {
          return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
        },
      },

    };



    let monitorsColumn = [
      {key: 'No', label: '#'},
      {key: 'watchType', label: 'Type', sortable: true, sortDirection: 'desc'},
      {key: 'unitType', label: 'Units', sortable: true, sortDirection: 'desc'},
      {key: 'Amount', label: 'Amount', sortable: true, sortDirection: 'desc'},
      {key: 'value', label: 'Value', sortable: true, sortDirection: 'desc'},
      {key: 'threshold', label: 'Threshold', sortable: true, sortDirection: 'desc'},
      {key: 'dataGroup', label: 'Bucket', sortable: true, sortDirection: 'desc'},
      {key: 'imsi', label: 'IMSI', sortable: true, sortDirection: 'desc'},
    ];

    let alertsColumn = [
      {key: 'No', label: '#'},
      {key: 'description', label: 'Alerts', sortable: true, sortDirection: 'desc'},
      {key: 'date_created', label: 'Date', sortable: true, sortDirection: 'desc'},
      {key: 'imsi', label: 'IMSI', sortable: true, sortDirection: 'desc'}
    ];

    let dataPlansColumn = [
      {key: 'bucket_id', label: 'No'},
      {key: 'dataGroup', label: 'Bucket', sortable: true, sortDirection: 'desc'},
      {key: 'dateCreated', label: 'Date', sortable: true, sortDirection: 'desc'},
      {key: 'actionType', label: 'Type', sortable: true, sortDirection: 'desc'},
      {key: 'unitType', label: 'Units', sortable: true, sortDirection: 'desc'},
      {key: 'thresholdValue', label: 'Threshold', sortable: true, sortDirection: 'desc'},
      {key: 'currentValue', label: 'Value', sortable: true, sortDirection: 'desc'},
      {key: 'action', label: ''},
    ];
</script>
